import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const nav = useNavigate();

  const handleLogout = () => { logout(); nav('/'); };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <svg className="navbar-logo-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="18" width="7" height="10" rx="1.5" fill="#0D7A8A"/>
            <rect x="13" y="12" width="7" height="16" rx="1.5" fill="#0D7A8A"/>
            <rect x="22" y="6" width="7" height="22" rx="1.5" fill="#0D7A8A"/>
            <circle cx="25.5" cy="3.5" r="2.5" fill="#1A3A5C"/>
          </svg>
          <span className="navbar-logo-text">PropertyTraining<span className="navbar-logo-ai">.ai</span></span>
        </Link>

        <div className="navbar-links">
          {!user ? (
            <>
              <Link to="/courses" className="navbar-link">Courses</Link>
              <Link to="/about" className="navbar-link">About Us</Link>
              <Link to="/login" className="navbar-link">Sign in</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="navbar-link">My Learning</Link>
              <Link to="/certificates" className="navbar-link">Certificates</Link>
              {isAdmin && <Link to="/admin" className="navbar-link">Admin</Link>}
              <span className="navbar-user">{user.first_name || user.email}</span>
              <button onClick={handleLogout} className="btn btn-ghost btn-sm">Sign out</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
